<template>
    <div class="flex jc:right scroll-margin-top:16">
        <article class="client px:24 lh:24px py:9.5 bg:gray100 r:20 ml:30 w:fit-content float:right">
            <slot></slot>
        </article>
    </div>
</template>
